import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { fCurrency } from '../../utils/formatNumber';
import { getDisplayValue } from '../../utils/formatName';

export default class GridAmountCell extends Component {
    //props: value, id, field
    render() {
        const { field, row } = this.props;
        const displayValue = getDisplayValue(this.props.value, field, row);
        const value = displayValue || 0;
        const formattedAmount = fCurrency(value);
        return (
            <TableCell key={field.id} align="left">
                {formattedAmount}
            </TableCell>
        );
    }
}
